// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.excel-container {
  padding: 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.excel-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #000;
}

.excel-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.excel-table thead {
  background: var(--button-color);
  color: #fff;
}

.excel-table th {
  padding: 16px;
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  border-right: 1px solid var(--hover-color);
}

.excel-table th:last-child {
  border-right: none;
}

.excel-table th:first-child {
  width: 100px;
}

.excel-table th:last-child {
  width: 100px;
}

.excel-table tbody tr:nth-child(odd) {
  background: #fff;
}

.excel-table tbody tr:nth-child(even) {
  background: var(--background-color);
}

.excel-table tbody tr:hover {
  background: #e8e8e8;
}

.excel-table td {
  padding: 16px;
  font-size: 14px;
  color: #000;
  border-right: 1px solid var(--button-color);
}

.excel-table td:last-child {
  border-right: none;
}

.checkbox-active {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.excel-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-download-icon,
.btn-delete-icon {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  color: var(--button-color);
}

.btn-download-icon:hover,
.btn-delete-icon:hover {
  opacity: 0.7;
}

.empty-state {
  text-align: center;
  padding: 60px;
  color: #999;
  font-size: 16px;
}

.loading {
  text-align: center;
  padding: 60px;
  font-size: 18px;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/components/History/ExcelManager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb","sourcesContent":[".excel-container {\n  padding: 40px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.excel-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 30px;\n  color: #000;\n}\n\n.excel-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.excel-table thead {\n  background: var(--button-color);\n  color: #fff;\n}\n\n.excel-table th {\n  padding: 16px;\n  text-align: left;\n  font-weight: 500;\n  font-size: 14px;\n  border-right: 1px solid var(--hover-color);\n}\n\n.excel-table th:last-child {\n  border-right: none;\n}\n\n.excel-table th:first-child {\n  width: 100px;\n}\n\n.excel-table th:last-child {\n  width: 100px;\n}\n\n.excel-table tbody tr:nth-child(odd) {\n  background: #fff;\n}\n\n.excel-table tbody tr:nth-child(even) {\n  background: var(--background-color);\n}\n\n.excel-table tbody tr:hover {\n  background: #e8e8e8;\n}\n\n.excel-table td {\n  padding: 16px;\n  font-size: 14px;\n  color: #000;\n  border-right: 1px solid var(--button-color);\n}\n\n.excel-table td:last-child {\n  border-right: none;\n}\n\n.checkbox-active {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.excel-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.btn-download-icon,\n.btn-delete-icon {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  color: var(--button-color);\n}\n\n.btn-download-icon:hover,\n.btn-delete-icon:hover {\n  opacity: 0.7;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px;\n  color: #999;\n  font-size: 16px;\n}\n\n.loading {\n  text-align: center;\n  padding: 60px;\n  font-size: 18px;\n  color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
